import { useState } from 'react';
import { accountApi } from '../../api/account';
import { useSession, useUser } from '../../auth/session';
import { Field, FormError, useSubmit } from '../../components/Field';

/** Account → Delete account (doc 66): the password again and a tick; the owner's account stays. */
export function DeleteAccountPanel() {
  const user = useUser();
  const { signedOut } = useSession();
  const [password, setPassword] = useState('');
  const [understood, setUnderstood] = useState(false);
  // Signed out here, the app shows the sign-in page by itself, with the note.
  const form = useSubmit(() => accountApi.deleteOwn(password), () => { signedOut('Your account was deleted.'); });
  return (
    <section className="panel delete-account" aria-labelledby="delete-account-title">
      <h2 id="delete-account-title">Delete account</h2>
      {user.role === 'owner' ? (
        <p className="muted">The owner account cannot be deleted — Couch would have no owner.</p>
      ) : (
        <form onSubmit={form.submit} noValidate>
          <p className="muted">
            Deletes your account and everything in Couch that belongs to it: your machines&apos; connection (their agents stop
            working), workflows, runs, previews, chats and stored keys. Full-size pictures stay on your machines. Cloud machines
            Couch made for you must be deleted first. The nightly backups forget you within 14 days.
          </p>
          <Field label="Your password" name="password" type="password" value={password} onChange={setPassword} autoComplete="current-password" error={form.fieldErrors.password} />
          <label className="checkbox">
            <input type="checkbox" checked={understood} onChange={(e) => { setUnderstood(e.target.checked); }} />
            I understand that this cannot be undone.
          </label>
          <FormError message={form.formError} />
          <button type="submit" className="button-danger" disabled={!understood || !password || form.pending}>Delete my account</button>
        </form>
      )}
    </section>
  );
}
